import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import List from './components/List';
const OriginalData = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb homePath={'/dashboard'} routeSegments={[{ name: 'Dữ liệu gốc' }]} />
      </div>
      <List />
    </ContainerBody>
  );
};
export default compose(withPaginate)(OriginalData);
